import React from 'react';
const ExitModalSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g id="Group 20851">
        <path
          id="Vector"
          d="M14 0.000114223C10.287 0.000114223 6.72623 1.47509 4.10049 4.10059C1.47504 6.72626 0 10.2875 0 14.0001C0 17.7126 1.47498 21.2738 4.10049 23.8995C6.72617 26.525 10.2874 28 14 28C17.7126 28 21.2738 26.525 23.8995 23.8995C26.525 21.2739 28 17.7126 28 14.0001C28 11.5424 27.3531 9.12838 26.1243 7.00003C24.8955 4.87168 23.1283 3.10447 20.9999 1.87566C18.8716 0.64686 16.4575 0 13.9999 0L14 0.000114223ZM21.2103 19.7899C21.3996 19.9776 21.5061 20.2332 21.5061 20.5C21.5061 20.7667 21.3996 21.0223 21.2103 21.21C21.0226 21.3993 20.767 21.5058 20.5003 21.5058C20.2335 21.5058 19.978 21.3993 19.7902 21.21L14.0005 15.41L8.2107 21.21C8.02297 21.3993 7.76739 21.5058 7.50063 21.5058C7.23388 21.5058 6.97831 21.3993 6.79057 21.21C6.60128 21.0223 6.49481 20.7667 6.49481 20.5C6.49481 20.2332 6.60128 19.9776 6.79057 19.7899L12.5906 14.0002L6.79057 8.21043C6.537 7.95664 6.43789 7.587 6.53074 7.24054C6.6236 6.89389 6.89414 6.62334 7.24081 6.53048C7.58724 6.43763 7.95687 6.53673 8.2107 6.79031L14.0005 12.5903L19.7902 6.79031C20.044 6.53674 20.4137 6.43763 20.7601 6.53048C21.1068 6.62334 21.3773 6.89388 21.4702 7.24054C21.563 7.58697 21.4639 7.9566 21.2104 8.21043L15.4103 14.0002L21.2103 19.7899Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ExitModalSVG;
